const container = "_35sc1a9ym9u";
const chevron = "_35sczqc1p";

export { chevron, container };
import "./container.print.style.linaria.module.css";
//# sourceMappingURL=container.print.style.js.map
